
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    type: { type: String, default: "default" },
    block: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
  },
});
